'use strict';

var icon = {};

exports.__exports = icon;
//# sourceMappingURL=icon.cjs.map
